export default "__VITE_ASSET__e3778144__"